var React = require('react');

function DefaultTab (props) {
    return React.createElement("svg",props,React.createElement("circle",{"opacity":"0.6","cx":"7.5","cy":"7.5","r":"8","transform":"matrix(-1 0 0 1 16.5 1.5)","stroke":"#E8EFFF"}));
}

DefaultTab.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = DefaultTab;

DefaultTab.default = DefaultTab;
